var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { translate } from '@utils/i18n';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Button } from '@components/v2/Button';
import toast from 'react-hot-toast';
import { deficienciesPath } from '@routes';
import useDeleteDeficiency from '../../../hooks/useDeleteDeficiency';
const namespace = 'features.deficiencies.delete_modal';
function DeleteModal({ deficiencyId, toggleDialog }) {
    const { mutateAsync: deleteDeficiency } = useDeleteDeficiency();
    const onSubmit = () => __awaiter(this, void 0, void 0, function* () {
        yield deleteDeficiency({ id: deficiencyId });
        toggleDialog();
        window.location.href = deficienciesPath({});
        toast.success('Deficiency deleted successfully');
    });
    return (React.createElement(Dialog, { title: translate('title', { namespace, id: deficiencyId }), className: "qmb-dialog", onClose: toggleDialog },
        React.createElement("p", null, translate('confirm_delete', { namespace, id: deficiencyId })),
        React.createElement("div", { className: "modal__footer mt-3 pull-right", style: { justifyContent: 'space-between' } },
            React.createElement(Button, { type: "button", onClick: toggleDialog }, translate('cancel', { namespace: 'generic' })),
            React.createElement(Button, { onClick: () => {
                    void onSubmit();
                }, variant: "primary" }, translate('ok', { namespace: 'generic' })))));
}
export default DeleteModal;
